import React from 'react';
import ReactClass from 'create-react-class';
import Parse from 'parse';
import OpenActions from './open-actions';
import {Link} from 'react-router-dom'

// const COMPLETED = "completed";
// const ROLE_TM  = "TM";
// const ROLE_APL = "APL";
// const ROLE_PL = "PL";

export default ReactClass({

    getInitialState() {
        return {
            projects: [],
        }
    },

    componentDidMount() {
        this.fetchProjectList();
    },

    handleChange(event) {
        this.setState({[event.target.name]: event.target.value});
    },

    fetchProjectList() {

        let _this = this;
        let Membership = Parse.Object.extend("Membership");
        let query = new Parse.Query(Membership);
        query.equalTo("user", Parse.User.current());
        query.include("project");
        this.projectRequest =
            query.find().then(async (results) => {

                let projects = [];

                for(let membership of results){
                    let project = membership.get("project");

                    if(project && project.get("deleted") !== true) {
                        projects.push({
                            id: project.id,
                            name: project.get("name"),
                            code: project.get("code"),
                            mail: project.get("code") + "@atappmail.com",
                            link: "project/" + project.id,
                        });
                    }
                };

                _this.setState({
                    projects: projects,
                });

            }).catch(function(e){
                console.log(e);
            });
    },

    render() {
        return (
            <div>
                {
                    this.state.projects.length > 0 ? (
                        <div className="negative-margin">
                            <h2>Projects</h2>
                        <table className="table table-striped">
                            <thead>
                            <tr>
                                <th>Name</th>
                                <th>Code</th>
                                <th>E-mail</th>
                                <th>Open actions</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.projects.map((project) => {
                                return (
                                    <tr key={project.id} className="project">
                                        <td><Link to={project.link}>{project.name}</Link></td>
                                        <td>{project.code}</td>
                                        <td><a href={"mailto:" + project.mail}>{project.mail}</a></td>
                                        <td><OpenActions project={project} /></td>
                                    </tr>
                                );
                            })}
                            </tbody>
                        </table>
                        </div>
                    ) : (
                        <em>No projects added yet.<br /><br /></em>
                    )
                }

            </div>
        );
    },

});



// WEBPACK FOOTER //
// ./src/projects.js